module.exports = __webpack_public_path__ + "static/media/seguridad.1bb764cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/product-step/scrapping/seguridad.png
// module id = 1648
// module chunks = 0